import { reatomBoolean } from "@reatom/framework";

export const exportLogsModalAtom = reatomBoolean(false, "exportLogsModal");
